import ActionsRegistry from "./ActionsRegistry";

export const Request = async <TIn, TOut>(
  actionName: string,
  params: TIn,
  headers?: { [key: string]: string }
): Promise<TOut> => {
  const action = ActionsRegistry[`${actionName}`];
  if (!action) {
    console.error(`No handler found in action registry for ${actionName}`);
    return null as TOut;
  }

  return await action(params);
};
